import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function useDriverStatus() {
  const { user } = useAuth();
  const [status, setStatus] = useState({ is_driver: false, is_owner: false, loaded: false });

  useEffect(() => {
    if (!user) { setStatus({ is_driver: false, is_owner: false, loaded: true }); return; }
    let alive = true;
    api.get("/driver/me")
      .then(({ data }) => alive && setStatus({ ...data, loaded: true }))
      .catch(() => alive && setStatus({ is_driver: false, is_owner: false, loaded: true }));
    return () => { alive = false; };
  }, [user]);

  return status;
}
